<div class="weekly-hours-bar">
  <div class="weekly-hours-label">
    <h2 mat-dialog-title>{{ dialog_title() }}</h2>
    <p class="dialog-subtitle">{{ dialog_subtitle() }}</p>
  </div>
  <div class="weekly-hours-value-wrap">
    <span class="weekly-hours-value">
      {{ weekly_hours_configured() | hourDecimalToHoursMinutes }}
      @if (hours_per_week_expected(); as expected_hours) {
        / {{ expected_hours | hourDecimalToHoursMinutes }}
      }
    </span>
    @if (hours_per_week_expected() !== null) {
      @if (weekly_hours_total_correct()) {
        <mat-icon class="weekly-hours-status weekly-hours-status-ok" aria-hidden="true">check_circle</mat-icon>
      } @else {
        <mat-icon class="weekly-hours-status weekly-hours-status-error" aria-hidden="true">close</mat-icon>
      }
    }
  </div>
</div>
@if (is_week_exception_mode() && has_uncovered_blocked_meetings()) {
  <div class="meeting-coverage-warning-bar" role="alert">
    <mat-icon aria-hidden="true">warning</mat-icon>
    <span>{{ blocked_meetings_warning_message() }}</span>
  </div>
}
<mat-dialog-content>
  @if (loading()) {
    <p class="loading-message">Cargando…</p>
  } @else if (settings_error()) {
    <p class="loading-message">No se pudieron cargar los ajustes de horario.</p>
  } @else {
    <form [formGroup]="form" class="schedule-grid">
      @for (day of days_config; track day.key) {
        <div class="day-column" [class.day-time-ranges-invalid]="day_time_ranges_invalid()[day.key]">
          @if (is_normal_mode()) {
            <div class="remote-work-cell">
              <span class="remote-work-cell-spacer"></span>
              <mat-checkbox
                [checked]="isRemoteWorkDaySelected(day.key)"
                [disabled]="isRemoteWorkDayDisabled(day.key)"
                [attr.aria-label]="'Teletrabajo ' + day.label"
                (change)="toggleRemoteWorkDay(day.key, $event.checked)"
              >
                <span class="remote-work-emoji" matTooltip="Teletrabajo" matTooltipPosition="above">🏠</span>
              </mat-checkbox>
              <span class="remote-work-cell-spacer remote-work-cell-right">
                @if (day_time_ranges_invalid()[day.key]) {
                  <span
                    class="day-time-ranges-info"
                    [matTooltip]="time_ranges_validation_tooltip()"
                    matTooltipPosition="above"
                    aria-label="Información sobre franjas"
                  >
                    <mat-icon>info_outline</mat-icon>
                  </span>
                }
              </span>
            </div>
          }
          <div class="day-column-header">
            <div class="day-header-label">
              <span class="day-label">{{ day.shortLabel }}</span>
              <span
                class="day-hours"
                [class.day-hours-out-of-range]="day_hours_out_of_range()[day.key]"
                [matTooltip]="day_hours_out_of_range()[day.key] ? day_hours_range_tooltip() : null"
                matTooltipPosition="above"
              >
                {{ hours_per_day()[day.key] | hourDecimalToHoursMinutes }}
              </span>
            </div>
            <button
              mat-icon-button
              type="button"
              class="copy-day-btn"
              aria-label="Copiar horario del día"
              [disabled]="getPeriods(day.key).length === 0 || (is_week_exception_mode() && isDayDisabledInWeekException(day.key))"
              (click)="copyDay(day.key)"
            >
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <div [formArrayName]="day.key" class="periods-column">
            @if (getPeriods(day.key).length === 0) {
              <p class="no-schedule">Sin horario</p>
            } @else {
              @for (ctrl of getPeriods(day.key).controls; track ctrl) {
                <div [formGroupName]="$index" class="period-block">
                  <div class="period-header">
                    <span class="period-title">Franja {{ $index + 1 }}</span>
                    @if (!isPeriodDeleteLockedInWeekException(day.key, $index)) {
                      <button
                        mat-icon-button
                        type="button"
                        class="period-delete"
                        (click)="removePeriod(day.key, $index)"
                        aria-label="Eliminar franja"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                  </div>
                  <mat-form-field appearance="outline" class="period-field period-field-mt nobottom">
                    <mat-label>ENTRADA</mat-label>
                    <input
                      matInput
                      type="time"
                      formControlName="start_time"
                      [disabled]="isPeriodStartLockedInWeekException(day.key, $index)"
                    />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="period-field period-field-mt nobottom">
                    <mat-label>SALIDA</mat-label>
                    <input matInput type="time" formControlName="end_time" [disabled]="isPeriodEndLockedInWeekException(day.key, $index)" />
                  </mat-form-field>
                </div>
              }
            }
            <button
              mat-stroked-button
              type="button"
              class="add-period-btn"
              (click)="addPeriod(day.key)"
              [disabled]="isDayDisabledInWeekException(day.key)"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>
          @if (!is_normal_mode() && day_time_ranges_invalid()[day.key]) {
            <span
              class="day-time-ranges-info"
              [matTooltip]="time_ranges_validation_tooltip()"
              matTooltipPosition="above"
              aria-label="Información sobre franjas"
            >
              <mat-icon>info_outline</mat-icon>
            </span>
          }
        </div>
      }
    </form>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog()">Cancelar</button>
  <span [matTooltip]="save_button_tooltip()">
    <button mat-flat-button color="accent" (click)="save()" [disabled]="save_button_disabled()">
      @if (saving()) {
        Guardando…
      } @else {
        Guardar configuración
      }
    </button>
  </span>
</mat-dialog-actions>
